export const SWITCH_ROOM = 'SWITCH_ROOM'
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS'
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE'
